module.exports = __webpack_public_path__ + "static/media/Tostadas con mayonesa.1bfdabb7.jpg";